var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react'; // tslint:disable-line
import styled, { css } from 'styled-components';
import { classNames, firstStringProperty } from '@shapeable/utils';
var cls = classNames('image-entity');
import { breakpoints } from '@shapeable/theme';
import { Image } from '../elements/image';
import { pickBy, trim } from 'lodash';
import { ResponsiveContainer } from '../elements/responsive-container';
import { useEnv } from '../hooks/use-env';
export var ImageEntityDefaultProps = {
  showInfo: false
};
// -------- Styles -------->
var displayIf = function (flag) {
  return flag ? 'block' : 'none';
};
var ThumbnailStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 100%;\n  "], ["\n    max-width: 100%;\n  "])))
});
var NormalStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-width: 100%;\n    ", "\n  "], ["\n    max-width: 100%;\n    ", "\n  "])), function (props) {
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      display: ", ";\n    "], ["\n      display: ", ";\n    "])), displayIf(!props.hasPortrait));
  }),
  landscape: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      display: ", ";\n    "], ["\n      display: ", ";\n    "])), displayIf(!props.hasLandscape));
  }),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      display: ", ";\n    "], ["\n      display: ", ";\n    "])), displayIf(!props.hasTablet));
  }),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "]))),
  desktopLarge: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      display: ", ";\n    "], ["\n      display: ", ";\n    "])), displayIf(!props.hasLarge));
  })
});
var LandscapeStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  landscape: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "]))),
  tablet: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var TabletStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  tablet: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "]))),
  desktop: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var PortraitStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "]))),
  landscape: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var LargeStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "]))),
  desktopLarge: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "])))
});
// -------- Components -------->
var My = {
  Thumbnail: styled(Image)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ThumbnailStyles),
  Normal: styled(Image)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), NormalStyles),
  Portrait: styled(Image)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), PortraitStyles),
  Landscape: styled(Image)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), LandscapeStyles),
  Tablet: styled(Image)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), TabletStyles),
  Large: styled(Image)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), LargeStyles),
  ResponsiveContainer: ResponsiveContainer
};
export var ImageEntity = function (props) {
  var _a;
  var entity = props.entity,
    aspectRatio = props.aspectRatio,
    title = props.title,
    showInfo = props.showInfo;
  var env = useEnv();
  if (env.DEBUG_ENTITIES) {
    console.log("ImageEntity Entity:", entity);
    console.log("ImageEntity AspectRatio:", aspectRatio);
  }
  var image = entity.image,
    thumbnail = entity.thumbnail,
    portraitImage = entity.portraitImage,
    largeImage = entity.largeImage,
    tabletImage = entity.tabletImage,
    landscapeImage = entity.landscapeImage;
  var alt = trim(props.alt || firstStringProperty(entity, ['alternateText', 'description.plain', 'description.text']) || '', "\r\n");
  var longdesc = props.longdesc;
  var useThumbnail = props.useThumbnail && (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.url);
  var hasAspectRatio = !!aspectRatio;
  var className = !hasAspectRatio ? props.className : undefined;
  var textDescription = entity && entity.description && entity.description;
  var htmlDescription = entity && entity.description && entity.description;
  // const tooltipProps = 
  // favour html description 
  var description = htmlDescription || textDescription;
  var isHtml = !!htmlDescription;
  var tooltipProps = description && (_a = {}, _a['data-event'] = "click", _a['data-tip'] = description, _a['data-html'] = isHtml, _a);
  var imgProps = pickBy({
    alt: alt,
    title: title,
    longdesc: longdesc
  });
  var inner = useThumbnail ? React.createElement(My.Thumbnail, __assign({}, imgProps, {
    image: thumbnail
  })) : React.createElement(React.Fragment, null, React.createElement(My.Normal, __assign({}, imgProps, {
    hasPortrait: !!portraitImage,
    hasLandscape: !!landscapeImage,
    hasTablet: !!tabletImage,
    hasLarge: !!largeImage,
    image: image || thumbnail,
    className: cls.name(className)
  })), portraitImage && React.createElement(My.Portrait, __assign({}, imgProps, {
    image: portraitImage,
    className: className
  })), landscapeImage && React.createElement(My.Landscape, __assign({}, imgProps, {
    image: landscapeImage,
    className: className
  })), tabletImage && React.createElement(My.Tablet, __assign({}, imgProps, {
    image: tabletImage,
    className: className
  })), largeImage && React.createElement(My.Large, __assign({}, imgProps, {
    image: largeImage,
    className: className
  })));
  return hasAspectRatio ? React.createElement(My.ResponsiveContainer, {
    aspectRatio: aspectRatio,
    className: props.className
  }, inner) : inner;
};
ImageEntity.defaultProps = ImageEntityDefaultProps;
ImageEntity.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;